<div class="bg-deep-blue mb-3 mb-lg-5">
  <div class="d-flex justify-content-between align-items-center cabecalho">
    <div [ngClass]="{
      'cabecalho-placa' : dadosConsulta.placaEntrada || dadosConsulta.placaPesquisa,
      'cabecalho-placa-sem' : !dadosConsulta.placaEntrada || !dadosConsulta.placaPesquisa,
      'cabecalho-placa-mercosul' : placaMercosul && dadosConsulta?.placaEntrada
    }">
      <div *ngIf="dadosConsulta.placaEntrada || dadosConsulta.placaPesquisa" class="cabecalho-uf-Municipio">
        {{ emplacamento || '' }}</div>
      <div *ngIf="dadosConsulta.placaEntrada || dadosConsulta.placaPesquisa ">
        {{dadosConsulta?.placaEntrada || dadosConsulta?.placaPesquisa | appPlaca }}</div>
    </div>
    <img src="assets/images/brand_white_color.png" class="cabecalho-logo" loading="lazy">
    <div class="cabecalho-qrcode d-none d-md-block" id="qrcodeDecisaoCerta">
      <qrcode [qrdata]="qrcodeUrl" [width]="76"></qrcode>
    </div>
    <div class="cabecalho-qrcode d-md-none" id="qrcodeDecisaoCerta">
      <qrcode [qrdata]="qrcodeUrl" [width]="56"></qrcode>
    </div>
  </div>
</div>
